module.exports = __webpack_public_path__ + "static/media/GA-2100BWP-2AER_OR10_package.c474da45.jpg";